import React from "react";
import { DataTable } from "@/components/DataTable";
import { EmptyState } from "@/components/DataTable/States/Empty";
import { CalendarClock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useBulkMessageColumns } from "./columns";
import { TableHeader } from "./TableHeader";
import { useBulkMessagesTable } from "./useBulkMessagesTable";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

export const BulkMessagesTab = () => {
  const { t } = useTranslation();
  const { navToRoute } = useProtectedNavigation();
  const columns = useBulkMessageColumns();
  const {
    messagesData,
    loading,
    hasNextPage,
    hasPreviousPage,
    pageIndex,
    pageCount,
    handleFilterApply,
    getFilterDisplayValue,
    handleNextPage,
    handlePreviousPage,
    customFilters,
  } = useBulkMessagesTable();

  return (
    <DataTable
      data={messagesData}
      columns={columns}
      isLoading={loading}
      pagination={
        <>
          <DataTable.PaginationLabel
            pageCount={pageCount}
            pageIndex={pageIndex}
          />
          <DataTable.PaginationControls
            onNextPage={hasNextPage ? handleNextPage : false}
            onPreviousPage={hasPreviousPage ? handlePreviousPage : false}
          />
        </>
      }
      tableHeader={<DataTable.THeader />}
      tableBody={<DataTable.TBody />}
      emptyState={
        <EmptyState
          copy={t(
            "bulkMessaging.communityToolsOverview.tabs.bulkMessages.emptyState",
          )}
          buttonCopy={t("bulkMessaging.communityToolsOverview.createNewButton")}
          buttonTarget={() => {
            navToRoute("createBulkMessage");
          }}
          icon={
            <CalendarClock
              className="h-[36px] w-[36px] text-primary-light"
              aria-label={t(
                "bulkMessaging.communityToolsOverview.createNewButton",
              )}
            />
          }
        />
      }
      topHeader={
        <TableHeader
          onFilterChange={handleFilterApply}
          filterDisplayValue={getFilterDisplayValue()}
          customFilters={customFilters}
        />
      }
    />
  );
};
